// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1269":"css/app.7049","6010":"css/admin-app.7049"}[chunkId] + ".css";
};